<template>
    <div>
        <span v-if="status === 0" title="Crédits pappers épuisés ">
            <i class="fa-fw fas fa-exclamation-triangle text-danger"></i>
        </span>
        <span v-if="displayIntro">
            {{ introduction }}
        </span>
        {{ update }}
    </div>
</template>

<script>
export default {
    name: 'UpdateStatusDisplay',

    props: {
        displayIntro: false,
        status: null,
        update: null,
    },

    computed: {
        introduction() {
            return this.status === 0
                ? 'Crédits pappers épuisés'
                : 'Dernière mise à jour'
        },
    },
}
</script>

<style scoped></style>
